import ListPageView from "../../components/ListPageView"
import { useFilters } from "../../components/Filters/useFilters"

export default function HarborCare() {
  const ID_TEMPLATE = "harbor_care_activity_log"
  const ID_BLOCKS = ["activity__harbor_care", "activity"]
  const { filters, onFilterChange, clearAllFilters, onKeywordFilterChange } =
    useFilters()
  const listViewCols = [
    {
      header: "Date",
      field: "activity_date",
      block: "activity",
      type: "date",
    },
    {
      header: "Activity Name",
      field: "activity_name_hc",
      block: "activity__harbor_care",
      type: "string",
    },
    {
      header: "Activity Type",
      field: "activity_type_hc",
      block: "activity__harbor_care",
      type: "activity_type",
    },
    {
      header: "Attendees",
      field: "activity_attendance_hc",
      block: "activity__harbor_care",
      type: "string",
    },
    {
      header: "Submitted By",
      field: "staff_full_name",
      block: "activity",
      type: "staff",
    },
  ]

  const extraFilters = [
    {
      label: "Activity Type",
      id: "activity_type_hc",
      value: filters.activity_type_hc?.value || "",
      onChange: (e) => onFilterChange("activity_type_hc", e.value),
      onClear: () => onFilterChange("activity_type_hc", null),
      placeholder: "Select Activity Type",
      type: "select",
    },
    {
      label: "Activity Name",
      id: "activity_name_hc",
      value: filters.activity_name_hc?.value || "",
      onChange: (e) => onKeywordFilterChange("activity_name_hc", e),
      onClear: () => onFilterChange("activity_name_hc", ""),
      placeholder: "Search by Activity Name",
      type: "keyword",
    },
  ]

  return (
    <div className="main-content">
      <ListPageView
        idTemplate={ID_TEMPLATE}
        idBlocks={ID_BLOCKS}
        columns={listViewCols}
        extraFilters={extraFilters}
        filters={filters}
        clearAllFilters={clearAllFilters}
      />
    </div>
  )
}
